<template>
  <div>
    <div
      @click="$router.push('/groupons/' + groupon.id)"
      class="border-t border-b px-4 py-2 flex flex-row items-center bg-white">
      <div class="text-center w-24 h-24 flex items-center">
        <img :src="groupon.images[0].image" class="w-full max-h-full" />
      </div>
      <div class="flex flex-col text-sm pl-2">
        <div class="flex flex-row items-center">
          <div class="title">{{ groupon.title }}</div>
        </div>
        <div class="text-xs text-teal-300 my-1">拼团时间: {{ groupon.started_at }} 至 {{ groupon.end_at }}</div>
        <div class="flex flex-row items-baseline">
          <div class="text-ls-900 mr-2">￥{{ groupon.price }}</div>
          <div class="text-gray-500 text-xs line-through">￥{{ groupon.ori_price }}</div>
        </div>
        <div v-if="showStatus" class="text-teal-300 text-xs">状态： {{ groupon.status_text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showStatus: {
      type: Boolean,
      default: true
    },
    groupon: {
      type: Object,
      default: () => {
        return {
          id: '',
          title: '',
          images: [{ image: '', id: null }],
          started_at: '',
          end_at: '',
          ori_price: '',
          price: '',
          status_text: ''
        }
      }
    } // end of grouon
  }, // end of props
  computed: {
    id () {
      return this.$route.params.id
    }
  }
}
</script>
